import { Kinds } from "constants/product-collection";
import { getDefaultFieldValueByType } from "helpers/product-collection";

export const getFormatBlankFields = (itemDisplayProperty, brand) => {
    const blankItem = {
        _brand_id: {
            string_value: brand._id,
        },
        _product_revision: {
            string_value: "-1",
        },
    };
    const defaultValueFields = [];
    itemDisplayProperty.forEach((field) => {
        if (field.getIn(["detail_view", "display"], false) === true) {
            const key = field.get("field_name");
            const defaultValueField = field.getIn(["default_smu_value", "string_value"]);
            const isTitle = field.getIn(["detail_view", "is_title"]);
            if (defaultValueField || isTitle) {
                defaultValueFields.push(key);
            } else if (field.get("kind") === Kinds.BRAND_NAME) {
                blankItem[key] = { string_value: brand.name };
            } else {
                blankItem[key] = getDefaultFieldValueByType(field.get("value_type"));
            }
        }
    });
    return { blankItem, defaultValueFields };
};
